import React from 'react';
import { Modal } from 'antd';
import DF from '../../../DisplayFramework';
import { useModalState } from '../../../hooks/useModalState';
import PropDetail from 'pages/ProposalV3/PropDetail';

type ContractDetailModalProps = {
  visible: boolean;
  onCancel: () => void;
  ctrid: number;
  ctreference: string
  showAsModal?:boolean;
};

type ContractDetailProps = {
  ctrid: number;
  ctreference: string;
  showAsModal?:boolean;
};

const ContractDetailModal = ({ ctrid, ctreference,showAsModal }: ContractDetailProps) => {
  const { close, open, visible } = useModalState();
  return (
    <>
      <a
        onClick={(e) => {
          e.preventDefault();
          open();
        }}
      >
        {ctreference}
      </a>
      <ContractDetail
        showAsModal
        visible={visible}
        ctrid={ctrid}
        ctreference={ctreference}
        onCancel={close}
      />
    </>
  );
};

const ContractDetail = (props: ContractDetailModalProps) => {
  const { visible, onCancel, ctrid,showAsModal } = props;

  return (
    <DF.Provider pagcode="TODO">
      <Modal
        title="Contract Detail:"
        visible={visible}
        onCancel={onCancel}
        footer={null}
        width={1400}
      >
       <PropDetail ctrid={ctrid} phaseProp="PROD" showAsModal/>
      </Modal>
    </DF.Provider>
  );
};

export default ContractDetailModal;
